// extracted by mini-css-extract-plugin
export default {"warningMessage":"AssetForm_warningMessage__SjDHv"};